<template>
  <v-row>
    <v-col cols="12">
      <showIdeaProjectsStand 
        v-if="!loading && entrepreneurship.window.type_postulations_id===1" 
        :data="entrepreneurship" 
        :edition_aux="entrepreneurship.edition"/>

      <showIdeaProjectsSchoolsStand 
        v-if="!loading && entrepreneurship.window.type_postulations_id===2" 
        :data="entrepreneurship" 
        :edition_aux="entrepreneurship.edition"/>

      <showBusinessModelsStand
        v-if="!loading && entrepreneurship.window.type_postulations_id===3" 
        :data="entrepreneurship" 
        :edition_aux="entrepreneurship.edition"/>
    </v-col>

    <v-col cols="12" class="pt-8 d-sm-flex">
      <v-btn
        depressed
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        :to="{ name: 'showEntrepreneurshipOrganizer'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
      
      <v-spacer />
      
      <v-btn
        depressed
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        color="primary"
        disabled
        >
        Descargar PDF
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import showIdeaProjectsStand from '@/components/stand/showIdeaProjectsStand.vue'
  import showIdeaProjectsSchoolsStand from '@/components/stand/showIdeaProjectsSchoolsStand.vue'
  import showBusinessModelsStand from '@/components/stand/showBusinessModelsStand.vue'

  export default {
    name: 'showWindowOrganizer',
    components: { 
      showIdeaProjectsStand,
      showIdeaProjectsSchoolsStand,
      showBusinessModelsStand},
    data: () => ({
      loading:true,
      slug:'',
      edition_id:null,
      entrepreneurship_id:null,
      convocation_form_id:null,

      entrepreneurship:[],
    }),

    methods:{
      async getWindowOrganizer(){
        await axios.get('organizer/entrepreneurships/'+this.entrepreneurship_id+'/show-window').then(response =>{
          this.entrepreneurship = response.data.data
          
          //deshabilito el click para dar like/dislike
          this.entrepreneurship.window.handle_like = false

          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },
    },

    created(){
       this.edition_id = this.$route.params.edition_id;
       this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
       this.getWindowOrganizer()
    },
  }
</script>
<style>
.images {
  position: fixed;
}
</style>